
// export const API_PATH = "http://localhost:8000/";  // Dev Mode

export const API_PATH = "https://decaytreeedit-backend.onrender.com/";

// Helper function to handle API responses and dispatch error messages
export const handleApiResponse = async (response, dispatch) => {
    const data = await response.json();
    
    // Check if response status is not 200 or if there's an error field in the response
    if (!response.ok || data.error) {
        const errorMessage = data.error || `HTTP error! status: ${response.status}`;
        
        // Dispatch error message to Redux store
        if (dispatch) {
            const errorId = `error_${Date.now()}_${Math.random()}`;
            dispatch({
                type: 'SET_MESSAGE',
                payload: {
                    [errorId]: {
                        title: 'API Error',
                        color: 'danger',
                        message: errorMessage
                    }
                }
            });
        }
        
        throw new Error(errorMessage);
    }
    
    return data;
};

export const fetchBackends = async (dispatch = null) => {
    try {
        const response = await fetch(`${API_PATH}backends`);
        const data = await handleApiResponse(response, dispatch);
        return data.backends;
    } catch (error) {
        console.error('Error fetching backends:', error);
        throw error;
    }
};
